export default {
  创作即收益: "创作即收益<br />月月现金到账",
  加入EBC创作者激励计划: "加入EBC创作者激励计划，轻松变现影响力",
  成为创作者: "成为创作者",
  无限奖励: "无限奖励 全球曝光",
  EBC创作者激励计划:
    "EBC创作者激励计划，将您的优势转化为规模化收益，轻松提高“被动收入”",
  推荐奖励: "推荐奖励 人脉变现",
  推荐新用户注册并交易: "推荐新用户注册并交易，阶梯变现月月结算",
  内容变现: "内容变现 认知即资本",
  在EBC: "在EBC，知识不只是力量，更是收入",
  内容进阶: "内容进阶 全球曝光",
  从本地创作到全球影响: "从本地创作到全球影响，一步进阶，解锁世界级流量",
  预计奖金: "预计奖金/月",
  均值估算仅供参考: "*均值估算仅供参考",
  "800万交易者的信任首选": "500万交易者的信任首选",
  EBC用全球最佳券商的实力:
    "EBC用全球最佳券商的实力，将影响力转化为持续现金流，同时让您获得高额奖励、全球顶级IP资源",
  全方位媒体曝光: "全方位媒体曝光",
  我们以全球媒体资源:
    "我们以全球媒体资源、携手巴萨举办的多元化活动，为优质创作者提供内容扶持，助您快速建立个人品牌，提升品牌知名度。",
  全球最强交易环境: "全球最强交易环境",
  打造极致交易体验:
    "打造极致交易体验：毫秒级执行速度、机构级流动性、专业跟单社区，全方位助力安心交易，让知识轻松变现。",
  专属客户经理: "专属客户经理",
  我们为每位创作者配专属运营:
    "我们为每位创作者配专属运营，全程1对1指导，协助您高效产出内容，获取专业支持，收益最大化。",
  如何成为创作者: "如何成为创作者",
  从内容创作到奖励提现: "从内容创作到奖励提现，专属顾问全程1对1支持",
  立即加入:"立即加入",
  注册提交资料:"注册提交资料",
  发布专业内容:"发布专业内容",
  获取月度奖励:"获取月度奖励",
  活动须知:"活动须知",
  notices:[
    "1.创作者须拥有独立内容专栏、自媒体账号或社群渠道，具备至少3个月以上内容持续输出能力，内容形式包括但不限于策略分析、图文解读、视频课程等。",
    "2.内容需保持原创性、专业性与合规性。若存在抄袭、洗稿或违规发布行为，平台有权取消其参与资格与相关权益。",
    "3.每月将依据创作者达标等级进行结算，合格者将在次月第一周获得奖励。",
    "4.本活动与其他活动（如基金经理成长计划、代理扶持等）互斥，创作者需在报名时明确选择参与路径。",
    '5.平台将为优秀创作者配备专属运营协助提供内容支持与转化资源；可联系客服或邮件至 <a href="mailto:mkt@ebc.com">mkt@ebc.com</a>进行咨询。',
    "6.为保障活动公平性，EBC保留对本活动的最终解释权，并有权取消任何形式的违规或滥用行为的参与资格。"
  ],
  section4Tips:""
};
